import { SigmaWorkbookId } from "./sigma.types"

export const ENERGY_AND_WATER_USE_LEGACY_WORKBOOK_ID =
  SigmaWorkbookId.EnergyAndWaterUse

export const ENERGY_AND_WATER_USE_CORE_SCHEMA_WORKBOOK_ID =
  SigmaWorkbookId.EnergyAndWaterUseCoreSchema

export const ENERGY_AND_WATER_USE_CORE_SCHEMA_WORKBOOK_URL_ID =
  "2ICUI6MCNbeLOw8LSJDjgY"

export const getActiveEnergyAndWaterUseWorkbookId = (
  useCoreSchema: boolean
): string =>
  useCoreSchema
    ? ENERGY_AND_WATER_USE_CORE_SCHEMA_WORKBOOK_ID
    : ENERGY_AND_WATER_USE_LEGACY_WORKBOOK_ID

export const isEnergyAndWaterUseWorkbookId = (
  workbookId: string | undefined
): boolean =>
  workbookId === ENERGY_AND_WATER_USE_LEGACY_WORKBOOK_ID ||
  workbookId === ENERGY_AND_WATER_USE_CORE_SCHEMA_WORKBOOK_ID
